import { render, staticRenderFns } from "./StatChartLabel.vue?vue&type=template&id=97c4374c&scoped=true&"
import script from "./StatChartLabel.vue?vue&type=script&lang=js&"
export * from "./StatChartLabel.vue?vue&type=script&lang=js&"
import style0 from "./StatChartLabel.vue?vue&type=style&index=0&id=97c4374c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c4374c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/timefly-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97c4374c')) {
      api.createRecord('97c4374c', component.options)
    } else {
      api.reload('97c4374c', component.options)
    }
    module.hot.accept("./StatChartLabel.vue?vue&type=template&id=97c4374c&scoped=true&", function () {
      api.rerender('97c4374c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StatChartLabel.vue"
export default component.exports